export const selectCurrentLocation = (state) => state.certificateCreatorStore.currentLocation;
